exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fee-input[data-v-4c2e1cc0] {\n  max-width: 50px;\n}\n.fee-input[data-v-4c2e1cc0]::-webkit-inner-spin-button,\n.fee-input[data-v-4c2e1cc0]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n.description[data-v-4c2e1cc0] {\n  max-width: 100%;\n}\n.header-flex[data-v-4c2e1cc0] {\n  margin: 30px;\n  justify-content: space-between;\n}\n.settings-header[data-v-4c2e1cc0] {\n  justify-content: space-between;\n  align-items: center;\n}\n.settings-header button[data-v-4c2e1cc0] {\n  margin-right: 50px;\n}", ""]);

// exports
